import React, { useState, useEffect } from 'react'
import MinimalModal from './MinimalModal.js'
import 'bootstrap/dist/css/bootstrap.css'
import './css/styles.css'


const API_URL = 'https://3awcubk0k6.execute-api.eu-central-1.amazonaws.com/dev/download_file_via_token-prod'
const MSG_ERROR = 'The link has expired. You can download the analysis from the portal.\n\nDer Link ist abgelaufen. Die Analysen können über das Portal heruntergeladen werden.'
const URL_REDIRCT = 'https://oceamo-portal.com/Analysis'

function App() {

  function Iframe(props) {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />)
  }

  const [pdfUrl, setPdfUrl] = useState(null)
  const [message, setMessage] = useState(null)
  useEffect(() => {
    const search = window.location.search
    const params = new URLSearchParams(search)
    const token = params.get('token')
    const url = `${API_URL}?token=${token}`
    fetch(url)
    .then((resp) => {
      if (resp.ok) {
        return resp.json()
      } else {
        setMessage(MSG_ERROR)
        return {}
      }
    })
    .then((resp) => {
      if (resp['url'] !== undefined) {
        setPdfUrl(resp['url'])
      }
    })
    .catch((error) => {
      console.log(error)
    })

  }, [])

  const clearMessage = () => {
    setMessage(null)
    window.location.replace(URL_REDIRCT)
  }


  const iframe = `<iframe height="100vh" style="width: 100vw; height: 100vh" title="Oceamo PDF" src="${pdfUrl}" frameborder="no" allowtransparency="true" allowfullscreen="true"</iframe>`
  let content
  if (message !== null) {
    content = <MinimalModal
      message={ message }
      callback={ clearMessage }
    />
  } else {
    content = <Iframe iframe={iframe} />
  }
  return (
    <div className="App" style={{height: '100vh', width: '100vw', maxHeight: 'unset', margin: 'unset', overflow: 'hidden'}}>
      { content }
    </div>
  );
}

export default App;
